import React from "react";
import styled from "styled-components";

import Header from "../components/Header/Header";

import Menu from "../components/Menu";

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  position: relative;
  flex-grow: 2;
`;

const Inner = styled.div`
  max-width: 960px;
  margin: 100px auto;
`;

const List = styled.dl``;

const Question = styled.dt`
  font-weight: bold;
`;

const Answer = styled.dd``;

const FAQ = () => (
  <PageWrapper>
    <Header />
    <Content>
      <Menu />
      <Inner>
        <h1>FAQ</h1>
        <List>
          <Question>Wat is de Kieskaart?</Question>
          <Answer>
            <p>
              Ga je voor het eerst stemmen en/of weet je nog niet zo goed waar
              al die partijen nu voor staan? Dan kan de kieskaart van MNM je
              daarbij helpen!
            </p>

            <p>
              Kieskaart is een online platform dat jongeren een beter inzicht
              wil geven in het politieke landschap van hun gemeente. Aan de hand
              van een interactieve kaart vol emoji’s, kunnen jongeren
              achterhalen welke veranderingen de partijen in hun gemeente willen
              doorvoeren. Alle partijen in Vlaanderen en Brussel kregen de kans
              om aan de hand van emoji’s maximum vijf voorstellen te doen voor
              hun gemeente. Die emoji’s worden per gemeente weergegeven op een
              interactieve kaart. Elke emoji op de kaart is gekoppeld aan een
              standpunt van een bepaalde partij in jouw gemeente. Daarnaast
              biedt kieskaart je ook een overzicht van de partijen in jouw
              gemeente en hun voorstellen.
            </p>
          </Answer>

          <Question>Hoe werkt de Kieskaart?</Question>
          <Answer>
            <p>
              Via kieskaart.mnm.be kan je je gemeente ingeven. Zo kom je op een
              interactieve kaart terecht waar je de standpunten van de partijen
              in jouw gemeente kan raadplegen. Dat kan op twee manieren. Ofwel
              klik je bovenaan op de partij en krijg je een overzicht van alle
              standpunten van die partij en de daaraan gekoppelde emoji’s, ofwel
              klik je op een emoji op de kaart en krijg je het daaraan
              gekoppelde standpunt van een partij uit jouw gemeente.
            </p>
          </Answer>

          <Question>Wat als ik een voorstel aanstootgevend vind? </Question>
          <Answer>
            <p>
              In principe moeten alle partijen zich aan het huisreglement van de
              VRT houden. Dat houdt in dat wij niet verantwoordelijk zijn voor
              de formulering van de voorstellen. Daarnaast is het onmogelijk om
              alle voorstellen te lezen. Mocht je een voorstel zien dat
              aanstootgevend is, stuur dan een mailtje naar{" "}
              <a href="mailto:kieskaart@mnm.be">kieskaart@mnm.be</a> met een
              vermelding van de gemeente, partij en titel van het voorstel.
            </p>

            <p>
              De gebruiksvoorwaarden van de VRT vind je terug op{" "}
              <a
                href="https://www.vrt.be/nl/info/gebruiksvoorwaarden/"
                target="_blank"
                rel="noopener noreferrer"
              >
                deze link
              </a>.
            </p>
          </Answer>

          <Question>
            Ik ben politicus en heb geen code gekregen?<br />
            Mijn partij staat niet op de kaart, wat nu?
          </Question>
          <Answer>
            <p>
              Elke partij ontving een individuele code waarmee voorstellen
              ingediend kunnen worden. Die codes werden naar de lijsttrekker
              gestuurd. Indien jouw partij nog geen code heeft ontvangen of je
              partij niet op de kaart staat, laat dan gerust iets weten via{" "}
              <a href="mailto:kieskaart@mnm.be">kieskaart@mnm.be</a>. Dan
              bezorgen we een code en alle bijhorende informatie!
            </p>
          </Answer>

          <Question>Hoe kan ik de voorstellen van mijn partij delen?</Question>
          <Answer>
            <p>
              Wie voorstellen van zijn/haar partij wil delen, kan in die
              gemeente doorklikken op die partij. Boven de lijst kan je via de
              deelknop de voorstellen van de betreffende partij delen op het
              sociale mediakanaal naar keuze.
            </p>
          </Answer>

          <Question>
            Ik heb een foutje gemaakt, wat doe ik? (foute locatie, verkeerde
            emoji...)
          </Question>
          <Answer>
            <p>
              Met de code die naar de lijsttrekker van elke partij werd
              gestuurd, kan je telkens opnieuw inloggen op de website van de
              kieskaart. Vervolgens kun je voorstellen aanpassen of verwijderen
              en emoji’s verplaatsen of vervangen . Ben je de persoonlijke code
              kwijt? Contacteer ons via{" "}
              <a href="mailto:kieskaart@mnm.be">kieskaart@mnm.be</a>.
            </p>
          </Answer>

          <Question>
            Mijn punt is aangepast of verwijderd, hoe komt dit?
          </Question>
          <Answer>
            <p>
              Binnen de VRT dragen we onze huisregels hoog in het vaandel. Ook
              bij de kieskaart willen we benadrukken dat elk voorstel aan
              volgende regels moet voldoen:
            </p>
            <ul>
              <li>
                Niet schelden, niet beledigen, geen ongepast taalgebruik, geen
                persoonlijke aanvallen, geen ongewenste foto’s of video’s...
              </li>
              <li>
                Haatdragende, racistische of andere boodschappen die juridisch
                strafbaar zijn, worden verwijderd.
              </li>
              <li>Plaats geen reclame en/of spam.</li>
              <li>Schend niemands privacy.</li>
              <li>
                Flooding (zinloos herhalen) of trolling (provoceren van andere
                gebruikers) wordt niet toegestaan.
              </li>
            </ul>
            <p>
              Voorstellen die niet aan bovenstaande regels voldoen, worden
              verwijderd door onze redactie. Gebruikers kunnen ook zelf een
              voorstel als ‘ongepast’ of ‘aanstoo tgevend’ signaleren, maar het
              voorstel wordt pas effectief verwijderd na nazicht door onze
              redactie en als er effectief sprake is van bovenstaande regels die
              geschonden worden. Indien dat niet het geval is, hebben we het
              recht om ze aan te passen of te verwijderen.{" "}
            </p>

            <p>
              <em>
                VRT behoudt zich het recht om het huisreglement op elk moment te
                wijzigen.
              </em>
            </p>

            <p>
              Het volledige huisreglement kan worden geraadpleegd via deze link:{" "}
              <a
                href="https://www.vrt.be/nl/info/gebruiksvoorwaarden/"
                target="_blank"
                rel="noopener noreferrer"
              >
                deze link
              </a>.
            </p>
          </Answer>
          <Question>Tot wanneer kan ik mijn voorstellen indienen? </Question>
          <Answer>
            <p>
              Voorstellen kunnen in principe ingediend worden tot op de dag van
              de verkiezingen. Maar hoe sneller je ze invult, hoe meer mensen je
              natuurlijk kan bereiken!
            </p>
          </Answer>
        </List>
      </Inner>
    </Content>
  </PageWrapper>
);

export default FAQ;



// WEBPACK FOOTER //
// ./src/pages/FAQ.js